import React, { useState, useEffect } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { motion } from 'framer-motion';
import { Typography, Grid, Button } from '@mui/material';
import { Add } from '@mui/icons-material';

const PatientRecords = () => {
  const [editingPatient, setEditingPatient] = useState(null);

  const handleAddPatient = () => {
    setEditingPatient(null);
  };

  const patients = [
    { id: 1, name: 'John Doe', age: 30, condition: 'Flu' },
    { id: 2, name: 'Jane Smith', age: 25, condition: 'Allergy' },
    { id: 3, name: 'Robert Brown', age: 40, condition: 'Diabetes' }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={css(styles.container)}
    >
      <Typography variant='h4' className={css(styles.title)}>
        Patients Records
      </Typography>

      <Grid item xs={12}>
        <Button
          variant='contained'
          color='primary'
          startIcon={<Add />}
          onClick={handleAddPatient}
          className={css(styles.addButton)}
        >
          Add Patient
        </Button>
        <table className={css(styles.table)}>
          <thead>
            <tr>
              <th className={css(styles.th)}>ID</th>
              <th className={css(styles.th)}>Name</th>
              <th className={css(styles.th)}>Age</th>
              <th className={css(styles.th)}>Condition</th>
            </tr>
          </thead>
          <tbody>
            {patients.map((patient) => (
              <tr key={patient.id} className={css(styles.tr)}>
                <td className={css(styles.td)}>{patient.id}</td>
                <td className={css(styles.td)}>{patient.name}</td>
                <td className={css(styles.td)}>{patient.age}</td>
                <td className={css(styles.td)}>{patient.condition}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Grid>
    </motion.div>

  );
};

const styles = StyleSheet.create({
  container: {
    padding: '1.5rem',
    maxWidth: '1200px'
    // margin: '0 auto'
  },
  title: {
    color: '#1976d2',
    marginBottom: '1.5rem',
    fontWeight: 'bold',
    fontSize: '1.8rem',
    '@media (max-width: 600px)': {
      fontSize: '1.5rem'
    }
  },
  addButton: {
    backgroundColor: '#2783F7',
    '&:hover': {
      backgroundColor: '#1b6ed9'
    }
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: '#f9f9f9'
  },
  th: {
    backgroundColor: '#fff',
    color: '#000',
    padding: '10px',
    textAlign: 'left'
  },
  tr: {
    ':nth-child(even)': {
      backgroundColor: '#f2f2f2'
    }
  },
  td: {
    padding: '10px',
    borderBottom: '1px solid #ddd',
    color: '#000'
  }
});

export default PatientRecords;
